export default "#define GLSLIFY 1\nvarying vec2 vUv;\n\nvoid main() {\n  gl_Position = vec4(position.xy, 1.0, 1.0);\n  vUv = uv;\n}";